module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/rack-server/rackfront2.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/rack-server/rackfront2.png
// module id = 605
// module chunks = 0